<template>
	<div class="app-auth-layout">
		<div class="auth__container">
			<div class="auth__header">
				<div class="auth__logo">
					<div class="auth__logo-text">
						{{ $app.name }}
					</div>
				</div>
				<div class="auth__line">
					<div class="auth__line--one"></div>
					<div class="auth__line--two"></div>
				</div>
			</div>
			<div class="auth__center">
				<div class="auth__body">
					<div class="auth__title">
						<h4 v-html="$t('install_app.heading.login')"></h4>
					</div>
					<a-form  class="auth__form" @submit.stop.prevent="onSubmit()" novalidate>
						<a-form-item class="m-b-15" :validate-status="formstate && $v.form.shop.$invalid ? 'error' : ''" >
							<a-input 
								:addonAfter="$t('install_app.addon.after')" 
								:placeholder="$t('install_app.placeholder.shop')" 
								v-model="form.shop"
								:disabled="isLoading"
								name="shopify_store"
								size="large"
								spellcheck="false"
							/>
							<transition name="fade-in" mode="out-in">
								<div  v-if="formstate && !$v.form.shop.required" class="form-error">
									{{ $t('errors.required_field') }}
								</div>
								<div  v-else-if="formstate && !$v.form.shop.valid" class="form-error">
									{{ $t('errors.incorrect_url') }}
								</div>
							</transition>
						</a-form-item>
						<a-button class="m-b-25" type="primary" size='large' block html-type="submit" :disabled="isLoading" >
							{{ $t('install_app.btn.login')}}
						</a-button>
					</a-form>
					<div
						class="auth__desc"
						v-html="$t('install_app.shopify_store', {'image': imageShopify, 'link': shopify_reference_url })"
					>
					</div>
				</div>
				<div class="auth__body__footer">
					<a target="_blank" v-if="term_of_service_link" :href="term_of_service_link" :class="$prefixClass.link + '-sm'">{{ $t('install_app.link.term') }}</a>
					<div></div>
					<a target="_blank" v-if="privacy_policy_link" :href="privacy_policy_link" :class="$prefixClass.link + '-sm'">{{ $t('install_app.link.policy') }}</a>
				</div>
			</div>
			<div class="auth__below">
				<div class="auth__info-footer">
					<div class="d-flex" slot="a_product_of">
            A product of
            <h5 class="m-0 danger-color"> &nbsp PerfectApps </h5>
        	</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { types as typesAuth } from '@/modules/auth/constant'
export default {
	name : 'TInstallApp',
	metaInfo: {
		title: 'Install',
	},
	data () {
		return {
			term_of_service_link: "https://help.perfectapps.io/en/article/terms-of-service-1ia1se9/?1600759237221",
			privacy_policy_link: "https://help.perfectapps.io/en/article/privacy-policy-2xwygu/?1600759237219",
			shopify_reference_url: "https://go.onecommerce.io/Shopify-FireApps025",
			imageShopify: require('@/assets/images/icons/shopify.png'),
			form : {
				shop : '',
			},
			formstate : false,
			isLoading : false
		}
	},
	validations: () => ({
		form: {
			shop :{
				required,
				valid : function(value){
					var temp = value.replace(/.myshopify.com/gi, "");
					const regex = /[!@#$%^&*(),.?":{}|<>`']/gi;
					return !regex.test(temp)
				}
			}
		},
	}),
	methods:{
		...mapActions({
      login : typesAuth.actions.LOGIN,
		}),
		...mapMutations({
			logout : typesAuth.mutations.LOGOUT
		}),
		onSubmit(){
			this.formstate = true 
			if(!this.isLoading && !this.$v.form.$invalid){
				this.isLoading = true
				var shop = this.form.shop.replace(/.myshopify.com/gi, "");
				this.login({shop}).then((res)=>{
					let { status , data } = res.data
					if( status && data){
						window.location.href = data.redirect_url
					}
				})
				.catch((err)=>{
					console.log(err)
				})
				.finally(()=>{
					this.isLoading = false
				})
			}
		},
	}
}
</script>
